import randomstring from 'randomstring'

export default defineNuxtPlugin((nuxtApp) => {
  const store = nuxtApp.$store as any
  const tabid = sessionStorage.tabId && sessionStorage.closedLastTab !== '2' ? sessionStorage.tabId : sessionStorage.tabId = randomstring.generate({ length: 8, charset: 'alphanumeric', capitalization: 'lowercase', readable: true })
  sessionStorage.closedLastTab = '2'
  store.dispatch('setTabId', tabid)
  window.addEventListener('beforeunload', () => {
    sessionStorage.closedLastTab = '1'
  })
})